<template>
    <div class="app-radio-group" :class="data.radioCheckboxWrapper?data.radioCheckboxWrapper:''">
        <label v-for="(item, index) in data.list"
               :class="['customized-radio col-12 mt-1 mb-2 radio-default', data.customRadioType, data.disabled || item.disabled ? 'disabled' : '']"
               :key="index">
            <input type="radio" class="radio-inline"
                   :name="name"
                   :id="name+'-'+index"
                   :required="data.required"
                   :disabled="item.disabled || data.disabled"
                   
                   :value="item.id"
                   v-on="listeners"
                   ref="radio">
            <span class="outside">
                <span class="inside"/>
            </span>
            {{ item[data.listValueField] }}
        </label>
    </div>
</template>

<script>
import {InputMixin} from "./mixin/InputMixin.js";

export default {
    name: "RadioStage",
    mixins: [InputMixin],
};
</script>

